import React from 'react';
import { Redirect } from 'react-router-dom';
import FirebaseAuth from 'react-firebaseui/FirebaseAuth';

import Footer from '../_global/Footer.jsx';

import firebase from '../../utils/firebase';

import logo from '../../assets/img/logo.svg';
import '../../styles/layouts/LoginLayout.css';

const MODE_SIGN_IN = 'sign-in';
const MODE_SIGN_UP = 'sign-up';
const MODE_FORGOT_PASSWORD = 'forgot-password';

function Divider({ hidden }) {

    return (
        <span className={`divider${hidden ? ' hidden' : ''}`}>·</span>
    );
}

class LoginLayout extends React.Component {

    get uiConfig() {

        return {
            signInFlow: 'popup',
            signInOptions: [
                {
                    provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                    scopes: [
                        'public_profile',
                        'email'
                    ],
                    customParameters: this.state.reAuth ? {
                        auth_type: 'reauthenticate'
                    } : this.state.emailError ? {
                        auth_type: 'rerequest'
                    } : null
                },
                {
                    provider: firebase.auth.TwitterAuthProvider.PROVIDER_ID,
                    customParameters: this.state.reAuth ? {
                        force_login: true
                    } : null
                },
                {
                    provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                    customParameters: this.state.reAuth ? {
                        prompt: 'select_account'
                    } : null
                },
            ],
            credentialHelper: 'none',
            callbacks: {
                signInSuccessWithAuthResult: ({ additionalUserInfo: { isNewUser }, user }) => {

                    this.afterSignIn(user, isNewUser);

                    return false;
                }
            }
        };
    };

    firstField = React.createRef();

    state = {
        isLoggedIn: false,
        email: '',
        displayName: '',
        password: '',
        emailMode: '',
        message: '',
        remember: true,
        reAuth: false,
        emailError: false,
        allowed: true
    };

    changeLoading = loading => {

        return new Promise(resolve => {
            this.props.changeCover(loading, resolve);
        });
    };

    afterSignIn = (user, isNewUser) => {

        let p = Promise.resolve();
        let isLoggedIn = true;

        if (!user.email) {
            isLoggedIn = false;
            p = user.delete().then(() => {
                return new Promise(resolve => {

                    this.setState({
                        emailError: true,
                        reAuth: false,
                        message: 'An email address is required.'
                    }, resolve);
                });
            });
        } else if (isNewUser && !user.emailVerified) {

            const newLocation = document.createElement('a');
            newLocation.href = window.location.href;
            newLocation.pathname = 'projects';

            p = user.sendEmailVerification({
                url: newLocation.href
            });
        }

        return p.then(() => {

            const { remember } = this.state;
            const persistence = remember ? firebase.auth.Auth.Persistence.LOCAL : firebase.auth.Auth.Persistence.SESSION;

            return firebase.auth().setPersistence(persistence)
                .then(() => this.changeLoading(false))
                .then(() => {

                    return new Promise(resolve => {

                        this.setState({ isLoggedIn }, resolve);
                    });
            });
        });
    };

    onChangeAllowed = e => {

        this.setState({ allowed: !this.state.allowed });
    };
    
    onChangeEmail = ({ currentTarget: { value: email } }) => {

        this.setState({ email, message: '' });
    };

    onChangeDisplayName = ({ currentTarget: { value: displayName } }) => {

        this.setState({ displayName, message: '' });
    };

    onChangePassword = ({ currentTarget: { value: password } }) => {

        this.setState({ password, message: '' });
    };

    onSetEmailMode = ({ currentTarget: { value: emailMode } }) => {

        this.setState({ emailMode, message: '' });
    };

    onChangeRemember = ({ currentTarget: { checked: remember } }) => {

        this.setState({ remember });
    };
    onChangeReAuth = ({ currentTarget: { checked: reAuth } }) => {

        this.setState({ reAuth });
    };

    onSignInUser = e => {

        e.preventDefault();

        this.changeLoading(true)
            .then(() => {

                const { email, password } = this.state;

                return firebase.auth().signInWithEmailAndPassword(email, password);
            })
            .then(({ additionalUserInfo: { isNewUser }, user }) => this.afterSignIn(user, isNewUser))
            .catch(({ message }) => {

                this.setState({ message }, () => this.changeLoading(false));
            });
    };

    onSignUpUser = e => {

        e.preventDefault();

        this.changeLoading(true)
            .then(() => {

                const { email, password } = this.state;

                return firebase.auth().createUserWithEmailAndPassword(email, password);
            })
            .then(result => {

                const { displayName } = this.state;

                return firebase.auth().currentUser.updateProfile({ displayName }).then(() => result);
            })
            .then(({ additionalUserInfo: { isNewUser }, user }) => this.afterSignIn(user, isNewUser))
            .catch(({ message }) => {

                this.setState({ message }, () => this.changeLoading(false));
            });
    };

    onForgotPassword = e => {

        e.preventDefault();

        this.changeLoading(true)
            .then(() => {

                const { email } = this.state;

                return firebase.auth().sendPasswordResetEmail(email);
            })
            .catch(({ message }) => {

                this.setState({ message }, () => this.changeLoading(false));
            });
    };


    get firebaseAuth() {


        return (
            <div className="firebase-auth">
                <FirebaseAuth
                    key={`reauth/${this.state.reAuth ? 'yes':'no'}/${this.state.emailError ? 'yes':'no'}`}
                    uiConfig={this.uiConfig}
                    firebaseAuth={firebase.auth()}
                />
                <button
                    onClick={this.onSetEmailMode}
                    value={MODE_SIGN_IN}
                    type="button"
                    className="firebaseui-idp-button mdl-button mdl-js-button mdl-button--raised firebaseui-idp-password firebaseui-id-idp-button"
                    data-provider-id="password" data-upgraded=",MaterialButton">
                        <span className="firebaseui-idp-icon-wrapper">
                            <img className="firebaseui-idp-icon" alt="" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg"/>
                        </span>
                    <span className="firebaseui-idp-text firebaseui-idp-text-long">Sign in with email</span>
                    <span className="firebaseui-idp-text firebaseui-idp-text-short">Email</span>
                </button>
            </div>
        );
    }

    get signIn() {

        return (
            <form onSubmit={this.onSignInUser}>

                <div className="well">
                    Don't have an account?<br />
                    <button className="btn btn-link" type="button" value={MODE_SIGN_UP} onClick={this.onSetEmailMode}>Sign up here.</button>
                </div>

                <div className="form-group">
                    <label htmlFor="email">
                        Email Address
                    </label>
                    <input
                        id="email"
                        type="email"
                        placeholder="jane@example.com"
                        className="form-control"
                        value={this.state.email}
                        onChange={this.onChangeEmail}
                        ref={this.firstField}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="password">
                        Password
                    </label>
                    <input
                        id="password"
                        type="password"
                        placeholder="8 characters minimum"
                        className="form-control"
                        value={this.state.password}
                        onChange={this.onChangePassword}
                        minLength={8}
                        autoComplete={this.state.reAuth ? 'off' : 'current-password'}
                        required
                    />
                </div>

                <div className="form-group clearfix">
                    <button
                        type="submit"
                        className="pull-right btn btn-success"
                        disabled={!this.state.email || this.state.password.length < 8}
                    >
                        Sign in
                    </button>
                    <button
                        type="button"
                        className="pull-right btn btn-default"
                        onClick={this.onSetEmailMode}
                        value=""
                    >
                        Cancel
                    </button>
                </div>
                <button
                    className="btn btn-link"
                    type="button"
                    onClick={this.onSetEmailMode}
                    value={MODE_FORGOT_PASSWORD}
                >
                    Forgot password?
                </button>

            </form>
        );
    }


    get signUp() {

        return (
            <form onSubmit={this.onSignUpUser}>

                <div className="well">
                    Already have an account?<br />
                    <button
                        type="button"
                        className="btn btn-link"
                        value={MODE_SIGN_IN}
                        onClick={this.onSetEmailMode}
                    >
                        Sign in here.
                    </button>
                </div>

                <div className="form-group">
                    <label htmlFor="email">
                        Email Address
                    </label>
                    <input
                        id="email"
                        type="email"
                        placeholder="jane@example.com"
                        className="form-control"
                        value={this.state.email}
                        onChange={this.onChangeEmail}
                        autoComplete="off"
                        ref={this.firstField}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="display-name">
                        Full Name
                    </label>
                    <input
                        id="display-name"
                        type="text"
                        placeholder="Jane Doe"
                        className="form-control"
                        value={this.state.displayName}
                        onChange={this.onChangeDisplayName}
                        autoComplete="off"
                        minLength={1}
                        maxLength={50}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="password">
                        Password
                    </label>
                    <input
                        id="password"
                        type="password"
                        placeholder="8 characters minimum"
                        className="form-control"
                        value={this.state.password}
                        onChange={this.onChangePassword}
                        minLength={8}
                        autoComplete="off"
                        required
                    />
                </div>

                <div className="form-group clearfix">
                    <button
                        type="submit"
                        className="btn btn-success pull-right"
                        disabled={!this.state.email || !this.state.displayName || this.state.password.length < 8}

                    >
                        Sign up
                    </button>
                    <button
                        type="button"
                        className="btn btn-default pull-right"
                        onClick={this.onSetEmailMode}
                        value=""
                    >
                        Cancel
                    </button>
                </div>

            </form>
        );
    }

    get forgotPassword() {


        return (
            <form onSubmit={this.onForgotPassword}>

                <div className="well">
                    We'll email you a password reset link.
                </div>

                <div className="form-group">
                    <label htmlFor="email">
                        Email Address
                    </label>
                    <input
                        id="email"
                        type="email"
                        className="form-control"
                        placeholder="jane@example.com"
                        value={this.state.email}
                        onChange={this.onChangeEmail}
                        autoComplete={this.state.reAuth ? 'off' : 'email'}
                        ref={this.firstField}
                        required
                    />
                </div>

                <div className="form-group clearfix">
                    <button
                        type="submit"
                        className="btn btn-success pull-right"
                        disabled={!this.state.email}
                    >
                        Send Email
                    </button>
                    <button
                        type="button"
                        className="btn btn-default pull-right"
                        onClick={this.onSetEmailMode}
                        value=""
                    >
                        Cancel
                    </button>
                </div>

            </form>
        );
    }

    get body() {

        switch(this.state.emailMode) {
            case MODE_SIGN_IN:
                return this.signIn;
            case MODE_SIGN_UP:
                return this.signUp;
            case MODE_FORGOT_PASSWORD:
                return this.forgotPassword;
            default:
                return this.firebaseAuth;
        }
    }

    get remember() {
        
        return (
            <div className="checkbox">
                <label>
                    <input
                        type="checkbox"
                        checked={this.state.remember}
                        onChange={this.onChangeRemember}
                    /> Remember me
                </label>
            </div>
        );
    }

    get reAuth() {
        
        return (
            <div className="checkbox">
                <label>
                    <input
                        type="checkbox"
                        checked={this.state.reAuth}
                        onChange={this.onChangeReAuth}
                    /> Re-authenticate
                </label>
            </div>
        );
    }

    render() {

        if (this.state.isLoggedIn) {

            return (
                <Redirect to="/" />
            );
        }

        return (
            <div className="layout login-layout">

                <div className="layout-content">
                    <nav className="navbar">
                        <div className="container-fluid">
                            <ul className="nav navbar-nav pull-right">
                                <li><a target="_blank" href="https://commentbox.io">Home</a></li>
                                <li><a target="_blank" href="https://commentbox.io/blog">Blog</a></li>
                                <li><a target="_blank" href="https://commentbox.io/docs">Docs</a></li>
                            </ul>
                        </div>
                    </nav>

                    <div className="container">

                        <div className="panel panel-default">
                            <div className="panel-body">

                                <img src={logo} />

                                <h3>Dashboard</h3>

                                <div className="body">
                                    {this.state.message ? (
                                        <div className="alert alert-danger" role="alert">
                                            {this.state.message}
                                        </div>
                                    ) : null}
                                    {this.body}
                                    <div style={this.state.allowed ? { display: 'none' } : null} className="not-allowed" />
                                </div>


                                <div className="disclaimer">
                                    By continuing, you are agreeing to our <a rel="nofollow" target="_blank" href="https://commentbox.io/terms">Terms of Service</a> and <a rel="nofollow" target="_blank" href="https://commentbox.io/privacy">Privacy Policy</a>.
                                </div>

                                <hr />

                                <div className="login-options">
                                    {this.remember}
                                    {this.reAuth}
                                </div>

                            </div>
                        </div>

                    </div>
                    <div className="push" />
                </div>

                <Footer />
            </div>
        );
    }
}

export default LoginLayout;


// WEBPACK FOOTER //
// ./src/components/layouts/LoginLayout.jsx